import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

import { GATEWAY_URL, GONDOLA_COOKIE } from '../config/auth.config';
import { deleteCookie, getCookie } from '../utils/auth.util';

/** Flag en `sessionStorage` para no entrar en un loop de redirecciones al gateway. */
const FORCED_LOGOUT_KEY = 'auth_forced_logout';

/**
 * Adjunta el JWT de Góndola a cada request. El gateway valida con la cookie
 * `gondola_session` o el header `Authorization: Bearer <jwt>`; se envían ambos:
 *  - `withCredentials` para que viaje la cookie (same-site),
 *  - y el Bearer leído de la cookie como fallback cross-site.
 *
 * En 401 con token presente (sesión expirada/rechazada) limpia la cookie y redirige al
 * gateway (que gestiona el login). Sin token no redirige, para no romper
 * entornos de desarrollo/demo sin sesión. (Mismo criterio que `gondola-billing-engine`.)
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = getCookie(GONDOLA_COOKIE);

  const authReq = req.clone({
    withCredentials: true,
    setHeaders: token ? { Authorization: `Bearer ${token}` } : {},
  });

  return next(authReq).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse && err.status === 401 && token) {
        try {
          deleteCookie(GONDOLA_COOKIE, '/');
        } catch {
          /* noop */
        }
        if (!sessionStorage.getItem(FORCED_LOGOUT_KEY)) {
          sessionStorage.setItem(FORCED_LOGOUT_KEY, '1');
          window.location.assign(GATEWAY_URL);
        }
      }
      return throwError(() => err);
    }),
  );
};
